<!--能耗排名 EnergyRanking-->
<template>
  <div class="EnergyRanking">
    <div class="ul">
      <div class="li">
        <div class="tit">
          <div class="name">
            能源类型能耗排名
            <div class="gengduo">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="right">
            <span>单位：tCO2</span>
            <el-select
              v-model="value1"
              size="mini"
              multiple
              collapse-tags
              placeholder="请选择"
              @change="aaa"
              class="seled"
            >
              <el-option
                v-for="(e, i) in optionsed"
                :key="i"
                :label="e"
                :value="e"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="center">
          <vchart style="height: 100%;" ref="vchart1"></vchart>
        </div>
      </div>
      <div class="li">
        <div class="tit">
          <div class="name">
            产线能耗排名
            <div class="gengduo">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="right">
            <span>单位：tCO2</span>
            <el-select
              v-model="value2"
              size="mini"
              placeholder="请选择"
              class="seled"
            >
              <el-option
                v-for="(e, i) in optionsed"
                :key="i"
                :label="e"
                :value="i"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="center">
          <vchart style="height: 100%;" ref="vchart2"></vchart>
        </div>
      </div>
      <div class="li">
        <div class="tit">
          <div class="name">
            工艺能耗排名
            <div class="gengduo">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="right">
            <span>单位：tCO2</span>
            <el-select
              v-model="value3"
              size="mini"
              placeholder="请选择"
              class="seled"
            >
              <el-option
                v-for="(e, i) in optionsed"
                :key="i"
                :label="e"
                :value="i"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="center">
          <vchart style="height: 100%;" ref="vchart3"></vchart>
        </div>
      </div>
      <div class="li">
        <div class="tit">
          <div class="name">
            班组能耗排名
            <div class="gengduo">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="right">
            <span>单位：tCO2</span>
            <el-select
              v-model="value4"
              size="mini"
              placeholder="请选择"
              class="seled"
            >
              <el-option
                v-for="(e, i) in optionsed"
                :key="i"
                :label="e"
                :value="i"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="center">
          <vchart style="height: 100%;" ref="vchart4"></vchart>
        </div>
      </div>
      <div class="li">
        <div class="tit">
          <div class="name">
            设备能耗排名
            <div class="gengduo">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="right">
            <span>单位：tCO2</span>
            <el-select
              v-model="value5"
              size="mini"
              placeholder="请选择"
              class="seled"
            >
              <el-option
                v-for="(e, i) in optionsed"
                :key="i"
                :label="e"
                :value="i"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="center">
          <vchart style="height: 100%;" ref="vchart5"></vchart>
        </div>
      </div>
      <div class="li">
        <div class="tit">
          <div class="name">
            产品能耗排名
            <div class="gengduo">
              查看更多 <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div class="right">
            <span>单位：tCO2</span>
            <el-select
              v-model="value6"
              size="mini"
              placeholder="请选择"
              class="seled"
            >
              <el-option
                v-for="(e, i) in optionsed"
                :key="i"
                :label="e"
                :value="i"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="center">
          <vchart style="height: 100%;" ref="vchart6"></vchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import vchart from "@/components/module/chart/vchart.vue";
export default {
  components: {
    vchart,
  },
  props: [],
  data() {
    return {
      dayOption: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        toolbox: {
          show: true,
          showTitle: true,
          right: 50,
          tooltip: {
            show: false,
            backgroundColor: "#fff",
            textStyle: {
              fontSize: 12,
            },
            extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);",
          },
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "10%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: ["汽", "气", "水", "电"],
        },
        series: [
          {
            type: "bar",
            data: [
              {
                value: 3053,
                itemStyle: {
                  color: "#9351fb",
                },
              },
              {
                value: 4053,
                itemStyle: {
                  color: "#4f653c",
                },
              },
              {
                value: 5052,
                itemStyle: {
                  color: "#4c6036",
                },
              },
              {
                value: 6050,
                itemStyle: {
                  color: "#baeb50",
                },
              },
            ],
            barMaxWidth: 15,
          },
        ],
      },

      value1: 0,
      value2: 0,
      value3: 0,
      value4: 0,
      value5: 0,
      value6: 0,
      optionsed: ["电", "水", "气", "汽"],
      OptionAll: {
        dataset: {
          source: [
            [1000, "电"],
            [920, "水"],
            [780, "气"],
            [400, "汽"],
          ],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          right: 20,
          bottom: 9,
          left: 10,
          top: 30,
          containLabel: true,
        },
        xAxis: { name: "amount" },
        yAxis: { type: "category" },

        series: [
          {
            type: "bar",
            itemStyle: {
              color: function(params) { 
                var d = ["#ffc53b", "#6a92ff", "#f286c4", "#53d382", "#1caecf"];
                if (params.dataIndex) {
                  return "#6a92ff";
                } else {
                  return "#ffc53b";
                }
              },
            },
            barWidth: 15, //柱图宽度
            encode: {
              x: "",
              y: "",
            },
          },
        ],
      },
      OptionOne: {
        dataset: {
          source: [
            [1000, "电"],
            [920, "水"],
            [780, "气"],
            [400, "汽"],
          ],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          right: 20,
          bottom: 9,
          left: 10,
          top: 30,
          containLabel: true,
        },
        xAxis: { name: "amount" },
        yAxis: { type: "category" },

        series: [
          {
            type: "bar",
            itemStyle: {
              color: function(params) {
                console.log(params, "paramsparams");
                var d = ["#ff8623", "#ffc53b", "#6a92ff", "#53d382"];
                return d[params.dataIndex];
              },
            },
            barWidth: 15, //柱图宽度
            encode: {
              x: "",
              y: "",
            },
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    // 1
    this.$refs.vchart1.setData(this.OptionAll, true);
    // 2
    var a = [
      [1008, "产线3"],
      [920, "产线2"],
      [810, "产线5"],
      [600, "产线1"],
      [400, "产线4"],
    ];
    this.OptionAll.dataset.source = a;
    this.$refs.vchart2.setData(this.OptionAll, true);

    // 3
    var a = [
      [1000, "工艺C"],
      [920, "工艺D"],
      [780, "工艺E"],
      [780, "工艺B"],
      [400, "工艺A"],
    ];
    this.OptionAll.dataset.source = a;
    this.$refs.vchart3.setData(this.OptionAll, true);

    // 4
    var a = [
      [1008, "班组3"],
      [920, "班组2"],
      [810, "班组5"],
      [600, "班组1"],
      [400, "班组4"],
    ];
    this.OptionAll.dataset.source = a;
    this.$refs.vchart4.setData(this.OptionAll, true);

    // 5
    var a = [
      [1008, "设备3"],
      [920, "设备2"],
      [810, "设备5"],
      [600, "设备1"],
      [400, "设备4"],
    ];
    this.OptionAll.dataset.source = a;
    this.$refs.vchart5.setData(this.OptionAll, true);

    // 6
    var a = [
      [1008, "产品3"],
      [920, "产品2"],
      [810, "产品5"],
      [600, "产品1"],
      [400, "产品4"],
    ];
    this.OptionAll.dataset.source = a;
    this.$refs.vchart6.setData(this.OptionAll, true);
  },
  destroyed() {},
  methods: {
    aaa(v){
     var source = [
            [1000, "电"],
            [920, "水"],
            [780, "气"],
            [400, "汽"],
          ];
          var d =[];
          source.map(b=>{
            v.map(a=>{
            if (a==b[1]) {
                d.push(b)
              }
          })
            })
        
     console.log(d,'dd');
      // 1  
   
    this.OptionAll.dataset.source = d;
    this.$refs.vchart1.setData(this.OptionAll, true);
    },
  },
};
</script>
<style scoped lang="scss">
.EnergyRanking {
  .ul {
    display: flex;
    flex-wrap: wrap;
    padding: 8px;
    justify-content: space-between;

    .li {
      width: calc(50% - 4px);
      background: #fff;
      height: 293px;
      box-sizing: border-box;
      padding: 20px;
      display: flex;
      flex-direction: column;
      margin-bottom: 8px;

      .tit {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .name {
          font-family: Microsoft YaHei;
          font-size: 16px;
          color: #1a1a1a;
          display: flex;
          align-items: center;

          .gengduo {
            font-family: Microsoft YaHei;
            font-size: 13px;
            color: #999;
            margin-left: 12px;
          }
        }

        .seled {
          margin-left: 10px;
        }
      }

      .center {
        flex: 1;
      }
    }
  }
}
</style>
<style>
.seled input {
  width: 140px;
}
</style>
